// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ce98ba8c","307":"bc28d654"}[chunkId] + ".chunk.js";
};